import Logo from 'src/assets/img/logo.png';

const Cover = (): JSX.Element => {return (
  <section className="hero">
    <div className="logo h" style={{ ['--d' as string]: 0 }}>
      <img src={Logo} alt="WERXPACE logo" width={242} height={242} />
    </div>
    <h1 className="h" style={{ ['--d' as string]: 1 }}>WerxPace</h1>
    <p className="slogan h" style={{ ['--d' as string]: 2 }}>
      Work together. <span className="c">Learn deeper.</span>
    </p>
    <p className="slogan-description h" style={{ ['--d' as string]: 3 }}>
      A collaboration platform that brings your people and tools together in focused workspaces for work, learning, and creative collaboration.
    </p>
  </section>
)};

export default Cover;
